import LoyaltyRewardsHeroSection from './LoyaltyRewardsHeroSection'
import LoyaltyRewardsIntroSection from './LoyaltyRewardsIntroSection'
import LoyaltyRewardsHowToFindSection from './LoyaltyRewardsHowToFindSection'
import LoyaltyRewardsOfferCarouselSection from './LoyaltyRewardsOfferCarouselSection'
import LoyaltyRewardsFaqSection from './LoyaltyRewardsFaqSection'

function LoyaltyRewardsPage() {
  return <div>
    <LoyaltyRewardsHeroSection />
    <LoyaltyRewardsIntroSection />
    <LoyaltyRewardsHowToFindSection />
    <LoyaltyRewardsOfferCarouselSection />
    <LoyaltyRewardsFaqSection />
  </div>
}

export default LoyaltyRewardsPage
